import type { PlanonReferenceKind } from '@hcc/types';
import { usePlanonReference, FIELD_LABEL_CLS, FIELD_INPUT_CLS } from './usePlanonReference';

/**
 * A dropdown backed by a cached Planon reference kind. The value is the
 * chosen Syscode (a number). A previously-set syscode that has fallen out of
 * the refreshed cache stays selectable so a copied value is never lost.
 */
export function RefSelect({
  kind,
  label,
  value,
  onChange,
}: {
  kind: PlanonReferenceKind;
  label: string;
  value: number | null;
  onChange: (v: number | null) => void;
}) {
  const q = usePlanonReference(kind);
  const entries = q.data?.entries ?? [];
  const known = value != null && entries.some((e) => e.syscode === value);
  return (
    <label className="block">
      <span className={FIELD_LABEL_CLS}>{label}</span>
      <select
        className={FIELD_INPUT_CLS}
        value={value ?? ''}
        disabled={q.isLoading}
        onChange={(e) => onChange(e.target.value === '' ? null : Number(e.target.value))}
      >
        <option value="">{q.isLoading ? 'Loading…' : 'Choose…'}</option>
        {value != null && !known ? <option value={value}>#{value} — not in cached list</option> : null}
        {entries.map((e) => (
          <option key={e.syscode} value={e.syscode}>
            {e.label}
          </option>
        ))}
      </select>
    </label>
  );
}
